import { LP_BUTTON_TYPE, type ApiBrandBenefit } from '@storefronts/common-types'
import type { LandingPageModel } from '../../models/landingPageModel'

export function getCartActionBrandBenefits(
    landingPage: Pick<
        LandingPageModel,
        'addToCartBrandBenefits' | 'buyNowBrandBenefits'
    >,
    buttonType?: string,
): ApiBrandBenefit[] {
    if (buttonType === LP_BUTTON_TYPE.ADD_TO_CART) {
        return landingPage.addToCartBrandBenefits
    }
    return landingPage.buyNowBrandBenefits
}

export function hasStickyFooterBrandBenefits(
    benefits: ApiBrandBenefit[],
    isBenefitsVisible: boolean,
): boolean {
    return benefits.length > 0 && isBenefitsVisible
}
